import { Trans, useTranslation } from 'react-i18next'

import { AcquiringItem } from 'app/dataTypes/acquiring/settings'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import visaImage from 'app/common/images/Visa-MasterCard-Maestro-Mir.png'

import RefillItem from './RefillItem'
import Offer from './Offer'

import styles from './PayTypeBankCart.module.scss';
import useCommissionText from './useCommissionText'


type Props = {
  className?: string
  amount: number
  acquiringItem: AcquiringItem | null
  onRefillClick: () => void
}

const PayTypeBankCart = ({ className, amount, acquiringItem, onRefillClick }: Props) => {
  const { t } = useTranslation('finances')

  const { offerURL = null } = acquiringItem || {}

  const commissionText = useCommissionText(amount, acquiringItem)

  return (
    <Offer offerURL={offerURL}>
      {toggleOffer => (
        <RefillItem
          className={className}
          firstColumnClassName={styles.firstColumnClassName}
          header={
            <span className={styles.header}>
              {t('bank_cart_pay_type_title', 'Банковская карта')}
              <img src={visaImage} className={styles.cards} alt="cards" />
            </span>
          }
          comment={
            <>
              {commissionText}
              {offerURL
                && <div className={styles.offerText}>
                  <Trans i18nKey="finances:bank_cart_offer_invitation">
                    {'Я принимаю условия '}
                    <PlainButtonAsLink onClick={toggleOffer}>{'оферты'}</PlainButtonAsLink>
                    {' об использовании сервиса оплаты'}
                  </Trans>
                </div>}
            </>
          }
          onRefillClick={onRefillClick}
        />
      )}
    </Offer>
  )
}

export default PayTypeBankCart
